import "./style.css";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

const FailedPayment = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        style={{
          animation: "2s ease alternate",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 40px)",
          flexDirection: "column",
        }}
      >
        <FontAwesomeIcon
          icon={faTriangleExclamation as IconDefinition}
          size="10x"
          color="#cc3300"
        />
        <Typography
          sx={{ textAlign: "center", fontSize: "50px", fontWeight: "600" }}
        >
          {t("Payment failed!")}
        </Typography>

        <Typography
          sx={{ textAlign: "center", fontSize: "30px", fontWeight: "400" }}
        >
          {t("Your request has failed.")}
        </Typography>
      </Box>
    </Box>
  );
};

export default FailedPayment;
